import React, { useCallback, useMemo, useState, useEffect } from 'react';
import { MaterialReactTable } from 'material-react-table';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  MenuItem,
  Stack,
  Autocomplete,
  TextField,
  Tooltip,
} from '@mui/material';
import { Delete, Edit } from '@mui/icons-material';
import { MRT_Localization_PT_BR } from 'material-react-table/locales/pt-BR';
import api from '../api/axios';

const lib = [
    'sim',
    'não',
]

const UsuarioDetran = () => {
  const [createModalOpen, setCreateModalOpen] = useState(false);
  const [tableData, setTableData] = useState({});
  const [userData, setUserData] = useState([])
  const [validationErrors, setValidationErrors] = useState({});

  const getUserList = async () => {
    await api.get('/user/list')
    .then(res => {
        res.data.map((item) => item.label = item.name)
        setUserData(res.data)
        //console.log(res.data)
    })
    .catch(err => console.log(err))
  }

  useEffect(() => {
    (async () => {
        await getUserList()
        await api.get('/useradmin/list')
            .then(res => {
                setTableData(res.data);
                //console.log(res.data)
            })
            .catch(err => console.log(err))

    })();
}, []);

  const handleCreateNewRow = async (values) => {
    if (!values.user) {
        alert('Usuário é obrigatório!!!')
        return;
    }
    delete values._id
	delete values.date_release
	values.released = values.released == 'sim' ? 'true' : 'false'

    await api.post('/useradmin/insert/', values)
    .then(res => {
        tableData.push(res.data);
        setTableData([...tableData]);
    })
    .catch(err => console.log(err))
};

  const handleSaveRowEdits = async ({ exitEditingMode, row, values }) => {
    if (!Object.keys(validationErrors).length) {
        values.released = values.released == 'sim' ? 'true' : 'false'
      tableData[row.index] = values;
      await api.put('/useradmin/update/' + values._id, values)
      .then(res => {
          setTableData([...tableData]);
        })
        .catch(err => console.log(err))
      exitEditingMode(); //required to exit editing mode and close modal
    }
  };

  const handleCancelRowEdits = () => {
    setValidationErrors({});
  };

  const handleDeleteRow = useCallback(
    async (row) => {
      if (
        !window.confirm(`Confirmar exclusão de ${row.getValue('user')}`)
      ) {
        return;
      }
      try {
        const response = await api.delete('/useradmin/delete/' + row.getValue('_id'));
        tableData.splice(row.index, 1);
        setTableData([...tableData]);
    } catch (error) {
        if (error.response) {
            console.log(error.response.status);
        } else if (error.request) {
            console.log(error.request);
        } else {
            console.log('Error', error.message);
        }
    }
    },
    [tableData],
  );

  const getCommonEditTextFieldProps = useCallback(
    (cell) => {
      return {
        error: !!validationErrors[cell.id],
        helperText: validationErrors[cell.id],
        onBlur: (event) => {
          const isValid =
            cell.column.id === 'email'
              ? validateEmail(event.target.value)
              : cell.column.id === 'date_release'
              ? cell.getValue()?.toLocaleDateString()
              : validateRequired(event.target.value);
          if (!isValid) {
            //set validation error for cell if invalid
            setValidationErrors({
              ...validationErrors,
              [cell.id]: `${cell.column.columnDef.header} is required`,
            });
          } else {
            //remove validation error for cell if valid
            delete validationErrors[cell.id];
            setValidationErrors({
              ...validationErrors,
            });
          }
        },
      };
    },
    [validationErrors],
  );

  const columns = useMemo(
    () => [
      {
        accessorKey: '_id',
        header: 'ID',
        enableColumnOrdering: false,
        enableEditing: false, //disable editing on this column
        enableSorting: false,
        size: 80,
      },
      {
        accessorKey: 'user',
        header: 'Usuário',
        size: 140,
        Cell: ({ cell }) => {
          var x = userData.filter(user => (user._id === cell.getValue()))
          return x[0].name
        },
        muiTableBodyCellEditTextFieldProps: ({ cell }) => ({
          children: userData.map((user) => (
              <MenuItem key={user._id} value={user._id}>
                {user.name}
              </MenuItem>
          )),
          select: true,
      }),
      },
      {
        accessorFn: (row) => new Date(row.date_release), //convert to Date for sorting and filtering
        accessorKey: 'date_release',
        header: 'Data',
        enableColumnOrdering: false,
        enableEditing: false, //disable editing on this column
        size: 80,
        Cell: ({ cell }) => cell.getValue()?.toLocaleDateString(),
        muiTableBodyCellEditTextFieldProps: ({ cell }) => ({
            ...getCommonEditTextFieldProps(cell),
            value: cell.getValue()?.toLocaleDateString()
          }),
      },
      {
        accessorFn: (row) => row.released ? 'sim' : 'não',
        accessorKey: 'released',
        header: 'Liberado',
        muiTableBodyCellEditTextFieldProps: ({ cell }) => ({
            ...getCommonEditTextFieldProps(cell),
            children: lib.map((lib) => (
                <MenuItem key={lib} value={lib}>
                  {lib}
                </MenuItem>
            )),
            select: true,
        }),
      },
    ],
    [getCommonEditTextFieldProps, userData],
  );

  return (
    userData.length > 0 ? (
      <>
      <MaterialReactTable
        displayColumnDefOptions={{
          'mrt-row-actions': {
            muiTableHeadCellProps: {
              align: 'center',
            },
            size: 120,
          },
        }}
        columns={columns}
        data={tableData}
        editingMode="modal" //default
        initialState={{ columnVisibility: { _id: false } }}
        enableColumnOrdering
        enableEditing
        localization={MRT_Localization_PT_BR}
        onEditingRowSave={handleSaveRowEdits}
        onEditingRowCancel={handleCancelRowEdits}
        renderRowActions={({ row, table }) => (
          <Box sx={{ display: 'flex', gap: '1rem' }}>
            <Tooltip arrow placement="left" title="Edit">
              <IconButton onClick={() => table.setEditingRow(row)}>
                <Edit />
              </IconButton>
            </Tooltip>
            <Tooltip arrow placement="right" title="Delete">
              <IconButton color="error" onClick={() => handleDeleteRow(row)}>
                <Delete />
              </IconButton>
            </Tooltip>
          </Box>
        )}
        renderTopToolbarCustomActions={() => (
          <Button
            color='warning'
            onClick={() => setCreateModalOpen(true)}
            variant="contained"
          >
            Criar Novo Usuário Detran
          </Button>
        )}
      />
      <CreateNewAccountModal
        columns={columns}
        open={createModalOpen}
        onClose={() => setCreateModalOpen(false)}
        onSubmit={handleCreateNewRow}
        users={userData}
      />
    </>) : <></>
  );
};

//example of creating a mui dialog modal for creating new rows
export const CreateNewAccountModal = ({ open, columns, onClose, onSubmit, users }) => {
  const [values, setValues] = useState(() =>
    columns.reduce((acc, column) => {
      acc[column.accessorKey ?? ''] = '';
      return acc;
    }, {}),
  );

  const handleSubmit = () => {
    //put your validation logic here
    onSubmit(values);
    onClose();
  };

  return (
    <Dialog open={open}>
      <DialogTitle textAlign="center">Criar Novo Usuário Detran</DialogTitle>
      <DialogContent>
        <form onSubmit={(e) => e.preventDefault()}>
          <Stack
            sx={{
              width: '100%',
              minWidth: { xs: '300px', sm: '360px', md: '400px' },
              gap: '1.5rem',
            }}
          >
            {columns.map((column) => (
              	column.header !== 'ID' && column.header !== 'Data' ?
              	column.header === 'Usuário' ?
					<Autocomplete
						disablePortal
						id="combo-box-demo"
						onChange={(e, value) => setValues({ ...values, [column.accessorKey]: value._id })}
						options={users}
						renderInput={(params) => <TextField {...params} label="Usuário" />}
					/> :
					<Autocomplete
						disablePortal
						id="combo-box-demo"
						onChange={(e, value) => setValues({ ...values, [column.accessorKey]: value.label })}
						options={[{label: 'sim'}, {label: 'não'}]}
						renderInput={(params) => <TextField {...params} label="Liberado" />}
					/> 
				: <></>
			))} 
          </Stack>
        </form>
      </DialogContent>
      <DialogActions sx={{ p: '1.25rem' }}>
        <Button onClick={onClose}>Cancelar</Button>
        <Button color="warning" onClick={handleSubmit} variant="contained">
          Salvar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const validateRequired = (value) => !!value.length;
const validateEmail = (email) =>
  !!email.length &&
  email
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    );
const validateAge = (age) => age >= 18 && age <= 50;

export default UsuarioDetran;

